import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '@app/core/app-config';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

export interface FairmintInvestmentStatus {
  widget_type: string;
  welcome_msg: string;
  latest_price: number;
  amount_invested: number;
  amount_earned: number;
  company_valuation: number;
  owners: number;
  cafe_name: string;
  signin_url: string;
  signup_url: string;
  investors: any[];
  performance: number;
  cafe_logo: string;
  company_logo_desktop: string;
  company_logo_mobile: string;
  company_logo: string;
  color1: string;
  color2: string;
  color_button: string;
  showAmountInvested: boolean;
  showCompanyValuation: boolean;
  showInvestors: boolean;
  showPerformance: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FairmintService {
  private httpClient: HttpClient;

  url: string = config.FAIRMINT_API_URL;

  override_signup_url: string = `https://invest.hospitable.com/series/rolling-safe`;

  constructor(private handler: HttpBackend) {
    // Bypass our interceptors as Fairmint are fussy about some of the headers we add in ours
    // https://medium.com/nerd-for-tech/how-to-bypass-angular-http-interceptor-2491afca16a3
    this.httpClient = new HttpClient(handler);
  }

  fetchInvestmentStatus(): Observable<FairmintInvestmentStatus> {
    return this.httpClient.get<FairmintInvestmentStatus>(this.url).pipe(
      map((investmentStatus: FairmintInvestmentStatus) => {
        investmentStatus.signup_url = this.override_signup_url;
        return investmentStatus;
      })
    );
  }
}
